export default "__VITE_ASSET__CIdsuTFX__"